import { Component, OnInit, HostListener} from '@angular/core';
import { ToursService } from 'src/app/_services/tours.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-tour-itinerary-detail',
  templateUrl: './tour-itinerary-detail.component.html',
  styleUrls: ['./tour-itinerary-detail.component.css'],
  providers: [NgbCarouselConfig]
})
export class TourItineraryDetailComponent implements OnInit {

  tourId;
  tourDetail;
  imagenes: any[]=[];
  itineraries: any[]=[];
  opcionalExcursion: any[]=[];
  showArrows: boolean;
  showIndicators: boolean;
  protected innerWidth: any;

  constructor(private tourService: ToursService,
    public router: Router,
    public activeRoute: ActivatedRoute,
    private datePipe: DatePipe,
    config: NgbCarouselConfig) {
      const id: string = this.activeRoute.snapshot.paramMap.get('tourid');
      console.log(id);
      if (Number(id) > 0) {
        this.tourId = Number(id);
      }
      config.showNavigationArrows = true;
      config.showNavigationIndicators = true;
      config.interval = 10000;
      config.animation = true;
      this.innerWidth = window.innerWidth;
     }

  ngOnInit(): void {
    if (this.innerWidth < 990) {
      this.showIndicators = true;
      this.showArrows = false;
    }
    else {
      this.showIndicators = false;
      this.showArrows = true;
    }
    this.loadImagen(this.tourId,0);
    this.loadTourDetail(this.tourId);
  }
  loadImagen(idtour,imagenType){
    this.tourService.getImageByType(idtour,imagenType).subscribe(img=>{
      console.log(img);
      this.imagenes = img;
    });
  }
  loadTourDetail(idtour){
    this.tourService.getTourDetail(idtour).subscribe(tour=>{
      this.tourDetail = tour;
      console.log(this.tourDetail);
      this.loadItineraries(this.tourDetail.id);
      this.loadOpcionalExcursion(this.tourDetail.id);
    });
  }
  loadItineraries(idtour){
    this.tourService.getItineraryByTour(idtour).subscribe(itin=>{      
      this.itineraries = itin.itinerario_slider;
    });
  }
  loadOpcionalExcursion(idtour){
    this.tourService.getOpcionalExcursionByTour(idtour).subscribe(opc=>{  
      this.opcionalExcursion = opc.excursiones_slider;
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = event.target.innerWidth;
    if (this.innerWidth < 990) {
      this.showIndicators = true;
      this.showArrows = false;
    }
    else {
      this.showIndicators = false;
      this.showArrows = true;
    }
  }
}
